import * as React from 'react';
import UIOptions from '../interfaces/UIOptions';
import Model from '../core/Model';
import Canvas from './Canvas';
import ResizeControls from '../../components/ResizeControls';
import Payload from '../interfaces/Payload';

import shallowCompare = require('react-addons-shallow-compare');

export interface ImageInlineEditorProps extends UIOptions {
    showSourceImage?: boolean;
    animatedGif?: boolean;
    allowPan?: boolean;
    outline?: number;
    onCropResize(
        width: number,
        height: number,
        payload: Payload,
        imageDataUrlGetter: () => string,
        keepAspect: boolean
    ): void;
    onCropResizeStart?(): void;
    onCropResizeEnd?(): void;
    onPan(payload: Payload): void;
    onPanStart?(): void;
    onPanEnd?(): void;
}

export default class ImageInlineEditor extends React.Component<ImageInlineEditorProps, {}> {
    private canvas: Canvas;

    shouldComponentUpdate(nextProps: ImageInlineEditorProps, nextState: {}) {
        const currentPayload = this.props.payload;
        const nextPayload = nextProps.payload;
        // temporary put currentPayload instead of next, because shallowCompare cannot detect deep changes
        nextProps.payload = currentPayload;

        const anyExceptPayloadChanged = shallowCompare(this, nextProps, nextState);
        // TODO use a library like lodash for comparisons, or immutable
        const payloadChanged = (
            currentPayload.cropXRatio !== nextPayload.cropXRatio
            || currentPayload.cropYRatio !== nextPayload.cropYRatio
            || currentPayload.zoom !== nextPayload.zoom
            || currentPayload.version !== nextPayload.version
        );
        // put back next payload
        nextProps.payload = nextPayload;

        return anyExceptPayloadChanged || payloadChanged;
    }

    render() {
        const props = this.props;
        return (
            <div>
                {!props.animatedGif ?
                <Canvas
                    ref={(ref: Canvas) => this.canvas = ref}
                    top={props.top}
                    left={props.left}
                    width={props.width}
                    height={props.height}
                    model={this.getModel()}
                    sourceImage={props.sourceImage}
                    zIndex={props.zIndex}
                    mediaType={props.mediaType}
                    position={props.position}
                    onPan={this.onPan}
                    onPanStart={props.onPanStart}
                    onPanEnd={this.onPanEnd}
                    showSourceImage={this.props.showSourceImage}
                    allowPan={props.allowPan}
                />
                : null}
                <ResizeControls
                    width={props.width}
                    height={props.height}
                    top={props.top}
                    left={props.left}
                    position={props.position}
                    zIndex={props.zIndex + 1}
                    resizeControls={props.resizeControls}
                    onResize={this.onCropResize}
                    onDragStart={this.onCropStart}
                    onDragEnd={this.onCropEnd}
                    outline={props.outline}
                    pointerEventsNone={!props.animatedGif}
                />
            </div>
        );
    }

    private getModel() {
        const props = this.props;
        return new Model(
            props.payload, props.sourceImage.width, props.sourceImage.height, props.width, props.height, props.maxWidth
        );
    }

    private getImageData() {
        return this.canvas.exportImageData();
    }

    private onPan = (dx: number, dy: number) => {
        const model = this.getModel();
        model.setCropPosition(
            model.getCropLeft() + dx,
            model.getCropTop() + dy
        );
        this.props.onPan(model.getPayload());
    };

    private onCropResize = (dx: number, dy: number, pos: string) => {
        const model = this.getModel();
        const cropWidth = this.props.width;
        const cropHeight = this.props.height;
        switch (pos) {
            case "S":
            model.resizeCropHeight(cropHeight + dy);
            break;
            case "E":
            model.resizeCropWidth(cropWidth + dx);
            break;
            case "SE":
            model.resizeCropKeepAspect(cropWidth + dx, cropHeight + dy);
            break;
            case "SW":
            model.resizeCropKeepAspect(cropWidth - dx, cropHeight + dy);
            break;
            case "W":
            model.resizeCropWidth(cropWidth - dx);
            break;
            default:
            break;
        }
        const keepAspect = (pos === "SE" || pos === "SW");
        this.props.onCropResize(
            model.getCropWidth(),
            model.getCropHeight(),
            model.getPayload(),
            () => this.getImageData(),
            keepAspect
        );
    };

    private onCropStart = () => {
        if (this.props.onCropResizeStart) {
            this.props.onCropResizeStart();
        }
    };

    private onCropEnd = () => {
        if (this.props.onCropResizeEnd) {
            this.props.onCropResizeEnd();
        }
    };

    private onPanEnd = () => {
        if (this.props.onPanEnd) {
            this.props.onPanEnd();
        }
    };
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/image-inline-editor/components/ImageInlineEditor.tsx
 **/